export default __webpack_public_path__ + "static/media/virus-bg.86b1a559.webp";